import { API_BASE } from "@/config"

import { authFetch } from "./authFetch"

export interface PlantAgent {
  name: string
  statusMessage: string
  groupName: string
  lastCommDateTime: string
  lastEvent: string
  eventDateTime: string
  usedGwbkBytes: number
  serverId: string
  status: "Connected" | "Trial Expired" | "Disconnected" | "Unknown"
  isHealthy: boolean
  usedMemoryMB: string
}

export interface NetworkConnection {
  networkAddress?: string | null
  direction: string
  connectionStatus: string
  ssl?: boolean | null
  faultCount?: number | null
  pingTime: number
  outgoing_rate?: number | null
  incoming_rate?: number | null
  systemName: string
  redundantRole: string
  connectionId: string
  version: string
  edition: string
  connections: NetworkConnection[]
}

export interface GatewayNetworkDiagram {
  localGatewayName: string
  redundantRole: string
  version: string
  edition: string
  connections: NetworkConnection[]
}

export interface GatewayOverview {
  totalConnections: number
  runningConnections: number
  outgoingByteRate?: number | null
  incomingByteRate?: number | null
  remoteGateways: number
}

export const getPlantStatuses = async (): Promise<PlantAgent[]> => {
  const response = await authFetch(`${API_BASE}/plants/status`)

  if (!response.ok) {
    throw new Error(`Failed to fetch plant statuses: ${response.statusText}`)
  }

  return response.json()
}

export const getPlantStatusByName = async (plantName: string): Promise<PlantAgent> => {
  const response = await authFetch(`${API_BASE}/plants/status/${encodeURIComponent(plantName)}`)

  if (!response.ok) {
    throw new Error(`Failed to fetch plant status for ${plantName}: ${response.statusText}`)
  }

  return response.json()
}

export const getGatewayNetworkDiagram = async (): Promise<GatewayNetworkDiagram> => {
  const response = await authFetch(`${API_BASE}/plants/network-diagram`)

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error("Access denied: SCADA diagnostics role required")
    }
    throw new Error(`Failed to fetch gateway network diagram: ${response.statusText}`)
  }

  return response.json()
}

export const getGatewayOverview = async (): Promise<GatewayOverview> => {
  const response = await authFetch(`${API_BASE}/plants/overview`)

  if (!response.ok) {
    if (response.status === 403) {
      throw new Error("Access denied: SCADA diagnostics role required")
    }
    throw new Error(`Failed to fetch gateway overview: ${response.statusText}`)
  }

  return response.json()
}
